import { h$1 as m, h as r, me as v, Y as u, m as f, o as A } from "../chunks/register-Ba9sFUKZ.js";
import * as y from "react";
import { f as w } from "../chunks/query-assigned-elements-CMnZBBH0.js";
import { o as k } from "../chunks/scale-B0YdpeZs.js";
import { d as I } from "../chunks/lifecycle-decorators-C04d1yHY.js";
const p = {
  beaconTagName: "beacon-accordion"
}, O = m`[beacon-tag-name=beacon-accordion]{--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-normal);--accordion-item-title-space-padding-block-normal: var(--beacon-reference-space-3);--accordion-item-title-space-padding-block-mini: calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block-jumbo: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-normal);--accordion-item-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200);--accordion-item-panel-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100)}[beacon-tag-name=beacon-accordion]:where([scale=mini]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-mini);--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-mini);--accordion-item-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100);--accordion-item-panel-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300)}[beacon-tag-name=beacon-accordion]:where([scale=jumbo]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-jumbo);--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-jumbo);--accordion-item-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-100)}[beacon-tag-name=beacon-accordion] [beacon-tag-name=beacon-accordion-item]{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0)}@media (width >= 640px){[beacon-tag-name=beacon-accordion]{--accordion-item-title-space-padding-block-normal: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block-mini: var(--beacon-reference-space-3);--accordion-item-title-space-padding-block-jumbo: var(--beacon-reference-space-2)}}@media (width >= 1280px){[beacon-tag-name=beacon-accordion]{--accordion-item-title-space-padding-block-normal: var(--beacon-reference-space-2);--accordion-item-title-space-padding-block-mini: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1))}}`, z = m`:host{--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-normal)}:host .hide{display:none}:host([scale=mini]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-mini)}:host([scale=jumbo]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-jumbo)}`;
var b = (o) => {
  throw TypeError(o);
}, h = (o, e, n) => e.has(o) || b("Cannot " + n), B = (o, e, n) => (h(o, e, "read from private field"), n ? n.call(o) : e.get(o)), S = (o, e, n) => e.has(o) ? b("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(o) : e.set(o, n), E = (o, e, n, c) => (h(o, e, "write to private field"), e.set(o, n), n), C = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, i = (o, e, n, c) => {
  for (var a = c > 1 ? void 0 : c ? $(e, n) : e, l = o.length - 1, d; l >= 0; l--)
    (d = o[l]) && (a = (c ? d(e, n, a) : d(a)) || a);
  return c && a && C(e, n, a), a;
};
const N = [16, 24, 32, 40];
function j(o) {
  return N.includes(o);
}
var s;
const g = class extends v {
  constructor() {
    super(...arguments), S(this, s), this.beaconTagName = p.beaconTagName, this.singleOpen = !1, this.scale = k.NORMAL, this._showAll = !0;
  }
  static get styles() {
    return [super.styles, z];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, O];
  }
  get iconSize() {
    return B(this, s);
  }
  set iconSize(e) {
    j(e) ? (E(this, s, e), this.style.setProperty(
      "--accordion-icon-column-size",
      String(this.iconSize) + "px"
    )) : this.style.removeProperty("--accordion-icon-column-size");
  }
  get AllAccordionItemsOpen() {
    var e, n;
    return (n = (e = this.slottedAccordionItems) == null ? void 0 : e.every((c) => c.open)) != null ? n : !1;
  }
  get AllAccordionItemsClosed() {
    var e, n;
    return (n = (e = this.slottedAccordionItems) == null ? void 0 : e.every((c) => !c.open)) != null ? n : !1;
  }
  closeAllAccordionItems() {
    this.slottedAccordionItems && !this.singleOpen && (this.slottedAccordionItems.forEach((e) => e.open = !1), this._showAll = !0);
  }
  openAllAccordionItems() {
    this.slottedAccordionItems && !this.singleOpen && (this.slottedAccordionItems.forEach((e) => e.open = !0), this._showAll = !1);
  }
  async initializeShowAll() {
    var e;
    await Promise.all(
      (e = this.slottedAccordionItems) == null ? void 0 : e.map((n) => n.updateComplete)
    ), this._showAll = !this.AllAccordionItemsOpen;
  }
  handleShowAllStateOnToggle() {
    this.AllAccordionItemsOpen && (this._showAll = !1), this.AllAccordionItemsClosed && (this._showAll = !0);
  }
  handleSingleOpenClick(e) {
    this.currentAccordionItemOpen && this.currentAccordionItemOpen !== e.target ? (this.currentAccordionItemOpen.removeAttribute("open"), this.currentAccordionItemOpen = e.target) : this.currentAccordionItemOpen = e.target;
  }
  /**
   * When `single-open` is set to true, maintains open/closed state of slotted in `<accordion-item>`'s
   */
  clickHandler(e) {
    this.singleOpen && this.handleSingleOpenClick(e);
  }
  render() {
    return u`
      <slot name="action-zone"></slot>
      <slot
        name="show-all"
        class=${this._showAll ? "" : "hide"}
        @beacon-event-click=${this.openAllAccordionItems}></slot>
      <slot
        name="hide-all"
        class=${this._showAll ? "hide" : ""}
        @beacon-event-click=${this.closeAllAccordionItems}></slot>
      <slot
        @beacon-event-click=${this.clickHandler}
        @beacon-event-toggle=${this.handleShowAllStateOnToggle}></slot>
    `;
  }
};
s = /* @__PURE__ */ new WeakMap(), g.tagName = p.beaconTagName;
let t = g;
i([
  r({ type: Boolean, attribute: "single-open" })
], t.prototype, "singleOpen", 2);
i([
  r({ type: String, reflect: !0 })
], t.prototype, "scale", 2);
i([
  r({ type: Number, attribute: "icon-size" })
], t.prototype, "iconSize", 1);
i([
  w({
    selector: '[beacon-tag-name="beacon-accordion-item"]'
  })
], t.prototype, "slottedAccordionItems", 2);
i([
  r({ reflect: !0, attribute: "show-all", type: Boolean })
], t.prototype, "_showAll", 2);
i([
  I
], t.prototype, "initializeShowAll", 1);
const R = (o) => (f(o, t), A({
  tagName: o ? o + "-" + t.tagName : t.tagName,
  elementClass: t,
  react: y,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  R as default,
  R as reactBeaconAccordion
};
